import { environment } from "src/environments/environment";

// export const APP_CONFIG = {
//   apiKey: 'PftL4NTf11XZM4DO7+ZgUWJ01aR4LPOYFHQ18sRYKhA=',
//   appId: 'sen3i-app-beta',
//   appName: 'Sen3i Beta'
// };


// app.config.ts


export const APP_CONFIG = {
  apiKey: environment.production 
    ? '1pj5Lahuqdnlh5+7l+yIHkSYkHxBM3HxOD4o0fIgPyI=' 
    : 'PftL4NTf11XZM4DO7+ZgUWJ01aR4LPOYFHQ18sRYKhA=',
  appId: environment.production 
    ? 'sen3i-app-production' 
    : 'sen3i-app-beta',
  appName: environment.production 
    ? 'Sen3i Live' 
    : 'Sen3i Beta'
};
